/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-06-08 17:45:15
 */

const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业商品列表
export const listByPage = params =>
  request(BASE_URL + '/entGoods/entPage', { params })
// 数量统计
export const statusCount = params =>
  request(BASE_URL + '/entGoods/count', { params })
// 操作列表数据
export const operateGoods = data =>
  request.post(BASE_URL + '/entGoods/handleGoods', data)

// 字典集合
export const allDictInfo = params =>
  request.get(BASE_URL + '/entGoods/entDictList', { params })
// 新增或修改商品
export const addOrEditProduct = params =>
  request.post(BASE_URL + '/entGoods/addOrEdit', params)
// 详情或编辑时反显
export const entProductDetail = params =>
  request.get(BASE_URL + '/entGoods/entDetail', { params })
// 商品管理-上传图片
export const uploadFile =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'
// 获取当前机构商品类型
export const getGoodsType = params =>
  request(BASE_URL + '/govGoods/getGoodsType', { params })
// 获取当前机构商品类型
export const getServiceTypeList = params =>
  request(BASE_URL + '/entGoods/getServiceTypeList', { params })

// 获取当前机构服务地区
export const getUserArea = params =>
  request(BASE_URL + '/entGoods/getUserArea', { params })
